import { buttonClasses, type Theme } from "@mui/material"
import { InlineSearchButtonTheme } from "core/themes/src/definitions/components.types"

export const createInlineSearchButtonTheme = (theme: Theme): InlineSearchButtonTheme => ({
    styleOverrides: {
        root: {
            [`&.${buttonClasses.contained}`]: {
                borderRadius: theme.radius.default,
            },
            marginLeft: "15px",
        },
    },
    variants: [],
})
